import { client, getUrl } from "utils";

export const getUserAgentsRequest = (filterParams) => client.get(getUrl("user-agents", filterParams));

export const addUserAgentRequest = (data) => client.post("user-agents", data);

export const deleteUserAgentRequest = (id) => client.delete(`user-agent/${id}`);
